
import angular from "angular";
import uiRouterModule from "@uirouter/angularjs";

import ErrorPageModuleConstants from "./Constants";
import ErrorPageController from "./ErrorPageController";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

function ErrorPageConfiguration($stateProvider) {
    $stateProvider.state(ErrorPageModuleConstants.rootStateName, {
        url: `/${ErrorPageModuleConstants.stateUrl}`,
        controller: ErrorPageController,
        controllerAs: ErrorPageController.controllerAs,
        template: ErrorPageController.template
    });
}

ErrorPageConfiguration.$inject = [
    "$stateProvider"
];

const errorPageModuleDependencies = DependencyListBuilder([
    ErrorPageController.dependencies,
    [ uiRouterModule ]
]);

export default angular
    .module("trackerbase-app.views.error-page", errorPageModuleDependencies)
    .config(ErrorPageConfiguration)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/error-page/index.js
// module id = NHgn
// module chunks = 1